import { OKTA_OIDC_CONFIG, OKTA_OIDC_CONFIG_DEV } from '../constants/okta.js';
import { getIsProd } from './get-is-prod.js';
export const getOktaConfigObject = () => {
    const isProd = getIsProd();
    return isProd ? OKTA_OIDC_CONFIG : OKTA_OIDC_CONFIG_DEV;
};
//# sourceMappingURL=get-okta-config-object.js.map